var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rtcPlayer"},[_c('video',{ref:"webRtcPlayerBox",staticClass:"webRtcPlayerBox",staticStyle:{"text-align":"left"},attrs:{"controls":"","autoplay":""}},[_vm._v("\n    Your browser is too old which doesn't support HTML5 video.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7924b95c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/rtcPlayer.vue
// module id = null
// module chunks = 